import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ImageHelper } from './../../../../../validator/image-helper';
import { AuthService } from './../../../../../services/auth.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { HelperService } from './../../../../../services/helper.service';
import { SpaceService } from './../../../../../services/space.service';

import _ from 'lodash';
@Component({
  selector: 'app-upload-video-modal',
  templateUrl: './upload-video-modal.component.html',
  styleUrls: ['./upload-video-modal.component.scss']
})
export class UploadVideoModalComponent implements OnInit {

  @Input() spaceData;
  @Output() uploadVideoEmit = new EventEmitter();
  @ViewChild('videoFile') videoFile: ElementRef;

  accessToken: any;

  public videoSrc = 'assets/images/drag-img.png';
  filesData = [];
  uploadObjErr: any;
  isSubmitted = false;

  uploadObjSuccess: any;
  videoUploadResponse = { status: '', message: '', filePath: '' };

  selectedFile: any;
  fileText: any;

  selectedVideoThumb: any;

  videoFormat = [
    'mp4',
    'mp3',
    '3gp',
    'flv',
    'ogg',
    'wmv',
    'webm',
  ];

  isVideoUploaded = false;

  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public spaceService: SpaceService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }


  onDropHandler(object) {
    this.uploadObjErr = undefined;
    this.filesData = [];
    if (object.event.dataTransfer.files.length === 0) { return; }
    if (object.event.dataTransfer.files.length > 1) {
      object.event.target.value = null;
      this.uploadObjErr = 'Please upload only one video file.';
      return;
    }

    this.selectedFile = object.event.dataTransfer.files[0] as File;

    const name = this.selectedFile && this.selectedFile.name;

    const fileExtension = name.split('.').pop();

    if (ImageHelper.isVideoSizeExceeded(this.selectedFile.size)) {
      object.event.target.value = null;
      this.uploadObjErr = 'Please upload file less than 500 MB.';
      return;
    }

    if (!ImageHelper.isVideoTypeValid(fileExtension)) {
      object.event.target.value = null;
      this.uploadObjErr = `Please upload valid file type (i.e ${this.videoFormat.toString()}).`;
      return;
    }


    if (!ImageHelper.isVideoTypeValid(fileExtension)) {
      object.event.target.value = null;
      this.uploadObjErr = `Please upload valid file type (i.e ${this.videoFormat.toString()}).`;
      return;
    }

    // Video reader
    this.isVideoUploaded = true;
    const thisobject = this;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(thisobject.selectedFile);
    fileReader.onload = () => {
      const blob = new Blob([fileReader.result], {type: thisobject.selectedFile.type});
      const url = URL.createObjectURL(blob);
      const video = document.createElement('video');
      const timeupdate = () => {
        if (snapImage()) {
          video.removeEventListener('timeupdate', timeupdate);
          video.pause();
        }
      };
      video.addEventListener('loadeddata', () => {
        if (snapImage()) {
          video.removeEventListener('timeupdate', timeupdate);
        }
      });
      const snapImage = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        const image = canvas.toDataURL();
        const success = image.length > 100000;
        if (success) {
          thisobject.selectedVideoThumb = document.createElement('img');
          thisobject.selectedVideoThumb.src = image;
          thisobject.isVideoUploaded = false;
          URL.revokeObjectURL(url);
        }
        return success;
      };
      video.addEventListener('timeupdate', timeupdate);
      video.preload = 'metadata';
      video.src = url;
      // Load video in Safari / IE11
      video.muted = true;
      video.play();
    };
  }

  onFileChangeVideo(event) {
    this.uploadObjErr = undefined;
    if (event.target.files.length === 0) { return; }
    this.selectedFile = event.target.files[0] as File;

    const name = this.selectedFile && this.selectedFile.name;

    const fileExtension = name.split('.').pop();

    if (ImageHelper.isVideoSizeExceeded(this.selectedFile.size)) {
      event.target.value = null;
      this.uploadObjErr = 'Please upload file less than 200 MB.';
      return;
    }

    if (!ImageHelper.isVideoTypeValid(fileExtension)) {
      event.target.value = null;
      this.uploadObjErr = `Please upload valid file type (i.e ${this.videoFormat.toString()}).`;
      return;
    }

    // Video reader
    this.isVideoUploaded = true;
    const thisobject = this;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(thisobject.selectedFile);
    fileReader.onload = () => {
      const blob = new Blob([fileReader.result], {type: thisobject.selectedFile.type});
      const url = URL.createObjectURL(blob);
      const video = document.createElement('video');
      const timeupdate = () => {
        if (snapImage()) {
          video.removeEventListener('timeupdate', timeupdate);
          video.pause();
        }
      };
      video.addEventListener('loadeddata', () => {
        if (snapImage()) {
          video.removeEventListener('timeupdate', timeupdate);
        }
      });
      const snapImage = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        const image = canvas.toDataURL();
        // const success = image.length > 100000;
        // if (success) {
        thisobject.selectedVideoThumb = document.createElement('img');
        thisobject.selectedVideoThumb.src = image;
        thisobject.isVideoUploaded = false;
        URL.revokeObjectURL(url);
        return true;
        // }
        // return success;
      };
      video.addEventListener('timeupdate', timeupdate);
      video.preload = 'metadata';
      video.src = url;
      // Load video in Safari / IE11
      video.muted = true;
      video.play();
      if (this.videoFile) {
        this.videoFile.nativeElement.value = '';
      }
    };

  }


  removeVideo() {
    this.selectedFile = undefined;
    this.selectedVideoThumb = undefined;
    this.resetErrorValues();
  }

  submit() {
    if (!this.selectedFile) {
      this.uploadObjErr = 'Video is required.';
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('uuid', this.spaceData.uuid);
    formData.append('type', 'video');
    this.spaceService.upload360Video(formData, this.accessToken).subscribe(
      (response) =>  {
        this.videoUploadResponse = response;
        if (response && response.success) {
          this.uploadObjSuccess = true;
          this.resetErrorValues();
          document.getElementById('closeUploadVideoModal').click();
          const responseData = response.data;
          this.uploadVideoEmit.emit(responseData);
        }

      },
      (err) => this.uploadObjErr = err.message
    );
  }

  resetErrorValues() {
    this.selectedVideoThumb = undefined;
    this.isSubmitted = false;
    this.uploadObjErr = undefined;
    this.uploadObjSuccess = undefined;
    this.isSubmitted = false;
    if (this.videoFile) {
      this.videoFile.nativeElement.value = '';
    }
  }
}
